import { TFunction } from 'i18next';
import { DeviceDetailsResponse_DeviceSpecificCommandSpec } from '@wavingroup/aqora-v2-api/wavin/aqora/v2/aqora_service_pb';
import {
  Command,
  DeviceSpecificCommand,
} from '@wavingroup/aqora-v2-api/wavin/aqora/v2/command_pb';

export class DeviceSpecificCommandModel {
  id: string;

  translationKey: string;

  acceptsPayload: boolean;

  payloadIsNumeric: boolean;

  constructor(commandSpec: DeviceDetailsResponse_DeviceSpecificCommandSpec) {
    this.id = commandSpec.id;
    this.translationKey = commandSpec.translationKey;
    this.acceptsPayload = commandSpec.acceptsPayload;
    this.payloadIsNumeric = commandSpec.payloadIsNumeric;
  }

  getTitle(t: TFunction): string {
    switch (this.translationKey) {
      case 'MPC_CLASSIC_SEARCH_TEMP_SENSOR':
        return t('device.commands.MPC_CLASSIC_SEARCH_TEMP_SENSOR.title');
      case 'MPC_CLASSIC_SWITCH_TEMP_SENSOR':
        return t('device.commands.MPC_CLASSIC_SWITCH_TEMP_SENSOR.title');
      case 'MPC_CLASSIC_CALIBRATE_WATER_HEIGHT':
        return t('device.commands.MPC_CLASSIC_CALIBRATE_WATER_HEIGHT.title');
      case 'MPC_CLASSIC_SWITCH_PARTICLE_CODE':
        return t('device.commands.MPC_CLASSIC_SWITCH_PARTICLE_CODE.title');
      case 'RWC_DISABLE_ALL':
        return t('device.commands.RWC_DISABLE_ALL.title');
      case 'ENABLE_DEMO_MODE':
        return t('device.commands.ENABLE_DEMO_MODE.title');
      case 'DISABLE_DEMO_MODE':
        return t('device.commands.DISABLE_DEMO_MODE.title');
      default:
        return '';
    }
  }

  getDescription(t: TFunction): string {
    switch (this.translationKey) {
      case 'MPC_CLASSIC_SEARCH_TEMP_SENSOR':
        return t('device.commands.MPC_CLASSIC_SEARCH_TEMP_SENSOR.description');
      case 'MPC_CLASSIC_SWITCH_TEMP_SENSOR':
        return t('device.commands.MPC_CLASSIC_SWITCH_TEMP_SENSOR.description');
      case 'MPC_CLASSIC_CALIBRATE_WATER_HEIGHT':
        return t(
          'device.commands.MPC_CLASSIC_CALIBRATE_WATER_HEIGHT.description',
        );
      case 'MPC_CLASSIC_SWITCH_PARTICLE_CODE':
        return t(
          'device.commands.MPC_CLASSIC_SWITCH_PARTICLE_CODE.description',
        );
      case 'RWC_DISABLE_ALL':
        return t('device.commands.RWC_DISABLE_ALL.description');
      case 'ENABLE_DEMO_MODE':
        return t('device.commands.ENABLE_DEMO_MODE.description');
      case 'DISABLE_DEMO_MODE':
        return t('device.commands.DISABLE_DEMO_MODE.description');
      default:
        return '';
    }
  }

  createCommand(content: string, resourceName: string): Command {
    let payload: DeviceSpecificCommand['payload'] | undefined;

    if (this.acceptsPayload && this.payloadIsNumeric) {
      payload = {
        value: parseFloat(content),
        case: 'number',
      };
    } else if (this.acceptsPayload && !this.payloadIsNumeric) {
      payload = {
        value: content,
        case: 'text',
      };
    }

    return new Command({
      resourceName,
      payload: {
        value: new DeviceSpecificCommand({
          id: this.id,
          payload,
        }),
        case: 'deviceSpecificCommand',
      },
    });
  }
}
